import React, { useEffect, useState } from "react";

import { Grid, Skeleton } from "antd";

import { useGetBanner } from "../../hooks/banner.hooks";
import { BannerResponse } from "../../hooks/data";
import PromotionBannerContainer from "./components/PromotionBannerContainer";

const PromotionBanner: React.FC = () => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const autoplayDelay = 5000; // ms

  const { data: banners, isLoading: loadingBanner } = useGetBanner({});
  const [visibleBanner, setVisibleBanner] = useState<BannerResponse[]>([]);

  useEffect(() => {
    if (!banners) return;
    if (screens.xs) {
      setVisibleBanner(banners);
    } else {
      setVisibleBanner([...banners, ...banners]);
    }
  }, [banners]);

  useEffect(() => {
    console.debug("vis", visibleBanner);
  }, [visibleBanner]);

  const renderLoading = () => {
    return (
      <div style={{ display: "flex", gap: "16px", justifyContent: "center" }}>
        {[1, 2, 3].map((i) => (
          <Skeleton.Button
            key={i}
            active
            style={{
              width: 616,
              height: 264,
              borderRadius: 12,
            }}
          />
        ))}
      </div>
    );
  };

  const handleOpenUrl = (url: string | null | undefined) => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <PromotionBannerContainer
      banners={banners}
      loadingBanner={loadingBanner}
      visibleBanner={visibleBanner}
      autoplayDelay={autoplayDelay}
      handleOpenUrl={handleOpenUrl}
      renderLoading={renderLoading}
    />
  );
};

export default PromotionBanner;
